import { useEffect, useState } from "react";

const DEFAULT_BREAKPOINT_PX = 768;

/**
 * Returns true when viewport width is at or below `breakpoint` px.
 * Reactive — re-renders the consumer on resize / device orientation change.
 *
 * Replacement for the old `isOnMobile()` function from util/HelperUtils.
 * Prefer CSS media queries when possible; use this hook only when JS-side
 * branching is unavoidable (e.g. switching React-Bootstrap props that aren't
 * stylable from CSS, or non-render logic).
 */
export const useIsMobile = (breakpoint: number = DEFAULT_BREAKPOINT_PX): boolean => {
  const query = `(max-width: ${breakpoint}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener("change", handler);
  }, [query]);

  return isMobile;
};
